<template>
  <v-layout column pa-5>
    <div class="align-center" style="width: 100%">
      <v-row
        align="center"
        justify="center"
        no-gutters>
          <v-img contain
            class="ma-2"
            max-width="300"
            :src="`${this.pathForPartnerBranding}default.png`"
            >
          </v-img>
      </v-row>
      <v-card
        v-if="covidURL"
        flat
        color="primary"
        class="mb-5 pa-5 intro-dark"
        dark
        >
        <v-row
          align="center"
          justify="center"
          no-gutters>
          <v-avatar tile >
            <v-img
            src="img/landing/cv_banner.png"
            ></v-img>
          </v-avatar>
          <v-card-title>{{ $t("login.covid19.title") }}</v-card-title>
        </v-row>
        <v-card-actions class="mb-0 pa-0">
          <v-btn id="bypass-login" x-large @click="bypass" style="font-size: 16px; width:100%;">
            {{ $t('login.start.title') }}
          </v-btn>
        </v-card-actions>
        <v-card-text class="white--text pa-0 mt-5">
          {{ $t('login.covid19.instructions') }}
        </v-card-text>
      </v-card>
      <v-card
        v-else
        class="my-2 pa-5 intro-dark"
        >
        <v-card-title class="pa-0 mb-5">
          <v-layout column>
            <v-row
              align="center"
              justify="center"
              no-gutters
              >
            </v-row>
            <v-row
              align="center"
              justify="center"
              no-gutters
              >
              <mrx-translation token="login.loginDrop.title"></mrx-translation>
            </v-row>
          </v-layout>
        </v-card-title>
        <v-card-text class="pa-0">
          <v-form class="mx-0">
            <v-text-field
              color="white"
              class="my-5"
              id="user"
              :label="$t('login.login.title')"
              v-model="code"
              name="login"
              outlined
              type="text"
              hide-details="auto"
            />
            <v-text-field
              color="white"
              id="password"
              class="my-5"
              v-model="password"
              hide-details="auto"
              :label="$t('login.password.title')"
              name="password"
              outlined
              type="password"
            />
            <v-select
              id="select-engagement"
              v-if="engagements.length > 0"
              v-on:change="login(engagement)"
              v-model="engagement"
              :items="engagements"
              :label="$t('login.engagements.title')"
              outlined
              item-color="white"
              class="my-5"
              hide-details="auto"
            ></v-select>
          </v-form>
        </v-card-text>

        <v-card-actions class="mb-0 pa-0">
          <v-layout column>
            <v-row
              align="center"
              justify="center"
              no-gutters
              >
              <v-btn id="login" style="font-size: 16px; width:100%;" x-large @click="access" text>{{ $t("login.login.title") }}</v-btn>
            </v-row>
            <v-divider class="my-5"></v-divider>
            <v-row no-gutters justify="center" align="center">
              <div class="d-flex">
                <v-icon class="pe-3">
                  {{ icons.mdiTranslate }}
                </v-icon>
                <v-select
                  v-model="language"
                  :items="languages"
                  hide-details="auto"
                  outlined
                  dense
                  item-color="white"
                  @change="updateLang">
                </v-select>
              </div>
            </v-row>
          </v-layout>
        </v-card-actions>
      </v-card>
    </div>
  </v-layout>
</template>

<script>
  import languageLogic from '@/mixins/languageLogic'
  import icons from '@/mixins/icons'
  import { mapActions, mapGetters } from 'vuex'

  const rtl = (lang) => {
    return lang === 'ar-EG' || lang === 'ar' || lang === 'ur' || false
  }

  const locale = (lang) => {
    if (lang === 'hi') return 'hi-u-nu-deva'
    if (lang === 'ar') return 'ar-u-nu-arabext'
    return lang
  }

  const fallback = (lang) => {
    let split = lang.split('-')
    if (split.length > 1) {
      return locale(split[0])
    }
    else {
      return lang
    }

  }


  export default {
    name: 'Login',
    mixins: [languageLogic, icons],
    data() {
      return {
        code: null,
        chosen: false,
        password: null,
        engagement: null,
        language: 'en-US'
      }
    },
    computed: {
      covidURL() {
        let res = false
        try {
          res = /covid/.test(window.location.hostname)
        }
        catch (e) {}
        return res
      },
      languages() {
        return [
          { text: 'English', value: 'en-US', rtl: false },
          { text: 'Français', value: 'fr', rtl: false },
          { text: 'Español', value: 'es-MX', rtl: false },
          { text: 'हिंदी', value: 'hi', rtl: false },
          { text: 'عربي - مصر', value: 'ar-EG', rtl: true },
          { text: 'Português', value: 'pt', rtl: false },
          { text: 'Hausa', value: 'ha', rtl: false },
          { text: 'Kreyòl', value: 'ht', rtl: false },
          { text: 'বাংলা', value: 'bn', rtl: false },
          { text: 'Somali', value: 'so', rtl: false },
          { text: 'Kiswahili', value: 'sw', rtl: false },
          { text: 'اردو', value: 'ur', rtl: true },
          { text: 'bahasa Indonesia', value: 'id', rtl: false },
          { text: 'IsiZulu', value: 'zu', rtl: false },
          { text: 'ភាសាខ្មែរ', value: 'km', rtl: false}
        ]
      },
      engagements() {
        return this.logins.map(x => {
          return {
            value: x.token,
            text: x.name
          }
        })
      },
      langForce() {
        return this.chosen ? `?loginLang=${this.language}` : ''
      },
      ...mapGetters({
          logins: 'v4/session/logins',
          all: 'v4/language/all',
          pathForPartnerBranding: 'v4/pathForPartnerBranding',
        })
    },
    methods: {
      bypass() {
        try {
          const deviceId = this.$getDeviceId()
          
          this.$track(this.$analyticsEvents.LOGIN_BYPASS_USED, {
            component: 'Login',
            language: this.language,
            is_covid_url: this.covidURL,
            device_id: deviceId
          })
          
          const isFirstTime = !localStorage.getItem('device_registered')
          if (isFirstTime) {
            this.$track(this.$analyticsEvents.DEVICE_REGISTERED, {
              device_id: deviceId,
              device_type: /Mobile|Android|iPhone/i.test(navigator.userAgent) ? 'mobile' : 'desktop',
              os_version: navigator.userAgent,
              language: this.language
            })
            localStorage.setItem('device_registered', 'true')
          }
        } catch (error) {
          // Silently fail if analytics tracking fails to ensure user can still access the app
        }
        
        document.location.href = `access/cv/exam${this.langForce}`
      },
      access() {
        try {
          const deviceId = this.$getDeviceId()
          
          this.$track(this.$analyticsEvents.LOGIN_ATTEMPTED, {
            component: 'Login',
            engagement_code: this.code,
            has_password: !!this.password,
            language: this.language,
            has_engagement_selected: !!this.engagement,
            device_id: deviceId
          })
          
          const isFirstTime = !localStorage.getItem('device_registered')
          if (isFirstTime) {
            this.$track(this.$analyticsEvents.DEVICE_REGISTERED, {
              device_id: deviceId,
              device_type: /Mobile|Android|iPhone/i.test(navigator.userAgent) ? 'mobile' : 'desktop',
              os_version: navigator.userAgent,
              language: this.language
            })
            localStorage.setItem('device_registered', 'true')
          }
        } catch (error) {
          // Silently fail if analytics tracking fails to ensure user can still access the app
        }
        
        document.location.href = `access/${this.code}/${this.password}${this.langForce}`
      },
      updateLang() {
        this.chosen = true
        this.$vuetify.rtl = rtl(this.language)
        this.$i18n.locale = locale(this.language)
        this.$i18n.fallbackLocale = fallback(this.language)
        this.$vuetify.lang.current = this.language
        this.$track(this.$analyticsEvents.LANGUAGE_CHANGED, {
          component: 'Login',
          language: this.language,
          is_rtl: rtl(this.language)
        })
      },
      ...mapActions({ previous: 'v4/navigate/previous', next: 'v4/navigate/next', login: 'v4/session/login' })
    }
  }
</script>

<style scoped>
  .v-select >>> .v-select__selections input {
    width: 0px !important;
  }

  .v-select >>> .v-select__selection {
    min-width: min-content !important;
  }

  .v-list {
    background-color: var(--deep-blue);
    border-style: solid;
    border-color: var(--white-70);
    border-width: 1px;
  }

  ::v-deep .v-list-item__content {
    color: white;
  }
  .v-select >>> .v-icon--svg {
    color: white !important;
  }
</style>
